import axios from 'axios'

module.exports = {
  props: ['star', 'order', 'images', 'translation', 'lang'],

  methods: {
    renameHero () {
      window.location.href = `/${this.lang}/?get-started&step=three`
    },

    changeStar () {
      window.location.href = `/${this.lang}/?get-started&step=six`
    }
  },

  template: `
  <div id="final" class="relative z-0">
    <book-preview class="d-none d-md-block" :images="images" v-if="images && images.length !== 0" />

    <book-preview-mobile class="d-md-none" :images="images" v-if="images && images.length !== 0" />

    <div class="container final d-lg-flex flex-wrap align-items-center px-lg-0">
      <div class="col">
        <div class="hero__preview-info">
          <div class="text-center">
            <a href="/cart" class="main-btn main-btn--green-light px-4 my-3">{{translation['Proceed to Checkout']}}</a>
          </div>

          <div class="hero__preview-block d-flex flex-wrap justify-content-center mr-lg-3">
            <div class="hero__preview-item d-flex justify-content-between h-pointer" @click="renameHero">
              <div>
                <p class="h-text-black h-text-xxs font-weight-bold h-uppercase">{{translation['Your Hero']}}</p>
                <p class="h-text-primary-cl">{{order.name}}</p>
              </div>
              <div class="d-flex ml-3 h-text-grey-cl-300">
                <p class="h-text-xxs font-weight-bold">EDIT</p>
                <i class="icon-edit h-text-sm ml-2"></i>
              </div>
            </div>
            <div class="hero__preview-item d-flex justify-content-between h-pointer" @click="changeStar">
              <div>
                <p class="h-text-black h-text-xxs font-weight-bold h-uppercase">{{translation['NHL Star']}}</p>
                <p class="h-text-primary-cl">{{ star.f_name }} {{ star.l_name }}</p>
              </div>
              <div class="d-flex ml-3 h-text-grey-cl-300">
                <p class="h-text-xxs font-weight-bold">EDIT</p>
                <i class="icon-edit h-text-sm ml-2"></i>
              </div>
            </div>
            <div class="hero__preview-item d-flex justify-content-between h-pointer" @click="$emit('open-dedication-modal')">
              <div>
                <p class="h-text-black h-text-xxs font-weight-bold h-uppercase">{{translation['Personalized Message']}}</p>
                <p class="h-text-primary-cl">{{translation['Customize']}}</p>
              </div>
              <div class="d-flex ml-3 h-text-grey-cl-300">
                <p class="h-text-xxs font-weight-bold">EDIT</p>
                <i class="icon-edit h-text-sm ml-2"></i>
              </div>
            </div>
            <div class="hero__preview-item d-flex justify-content-between h-pointer" @click="$emit('open-book-format-modal')">
              <div>
                <p class="h-text-black h-text-xxs font-weight-bold h-uppercase">{{translation['Book Format']}}</p>
                <p class="h-text-primary-cl">{{order.bookFormat.title.split(' ')[1]}}</p>
              </div>
              <div class="d-flex ml-3 h-text-grey-cl-300">
                <p class="h-text-xxs font-weight-bold">EDIT</p>
                <i class="icon-edit h-text-sm ml-2"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  `
}